import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=67b3a320&scoped=true"
import script from "./NewsArticle.vue?vue&type=script&lang=js"
export * from "./NewsArticle.vue?vue&type=script&lang=js"
import style0 from "./NewsArticle.vue?vue&type=style&index=0&id=67b3a320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3a320",
  null
  
)

export default component.exports